export { DailyInspectionModel } from './DailyInspection.model';
export { DailyInspectionModel2 } from './DailyInspection.model2';
